import { Loader2 } from 'lucide-react';

interface ModuleLoadingStateProps {
  message?: string;
}

const ModuleLoadingState = ({ message = "Loading module..." }: ModuleLoadingStateProps) => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="relative">
          <Loader2 className="h-12 w-12 animate-spin text-gray-400 mx-auto" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="h-8 w-8 bg-white rounded-full" />
          </div>
        </div>
        <p className="mt-4 text-gray-600 animate-pulse">{message}</p>
        
        {/* Loading progress dots */}
        <div className="flex justify-center space-x-2 mt-4">
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  );
};

export default ModuleLoadingState;